import React from "react";
import "./EfficiencyZone.css";

const EfficiencyZone = ({ percentage, title, subtitle, color }) => {
  return (
    <div className="efficiency-box" style={{ borderColor: color }}>
      <p className="efficiency-percentage" style={{ color }}>
        {percentage}%
      </p>
      <p className="efficiency-title">{title}</p>
      <p className="efficiency-subtitle">{subtitle}</p>
    </div>
  );
};

export default EfficiencyZone;
